import { Controller, useFormContext } from "react-hook-form";
import { AutocompleteSelect } from "./AutocompleteSelect";
import { YES_NO_OPTIONS } from "../../../../../features/customer/contract/constants";
import { useTranslation } from "react-i18next";

type Props = {
  name: string;
  rules?: any;
};

export const AutocompleteSelectField = ({ name, rules }: Props) => {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        ...(rules || {}),
      }}
      render={({ field: { value, onChange } }) => (
        <AutocompleteSelect
          value={value}
          onChange={onChange}
          options={YES_NO_OPTIONS}
          getOptionLabel={(option) => t(`common:${option}`)}
          getOptionValue={(option) => option}
        />
      )}
    />
  );
};
